import { registerPlugin } from "./utils/registerPlugin"

type NetworkSettingsPlugin = {
  openWifiSettings: () => Promise<void>
  openCellularSettings: () => Promise<void>
}

export const INetworkSettings =
  registerPlugin<NetworkSettingsPlugin>(
    "INetworkSettingsPlugin",
    {
      openWifiSettings: () => {
        throw new Error(
          "Wifi settings not supported on web platform"
        )
      },
      openCellularSettings: () => {
        throw new Error(
          "Cellular settings not supported on web platform"
        )
      },
    }
  )
